import { duration } from './duration.js';
import { _d2M } from './internal.js';
import * as MS from './ms.js';
export const durationAs = (durationInput, durationInputUnit, durationOutputAsUnit) => {
    const isOutputMonths = durationOutputAsUnit === 'M';
    if (isOutputMonths || durationOutputAsUnit === 'y') {
        let days = durationInput;
        switch (durationInputUnit) {
            case 'y':
                durationInput *= 12;
            /* falls through */
            case 'M':
                return isOutputMonths ? durationInput : durationInput / 12;
            case 'w':
                days *= 7;
                break;
            case 'h':
                days /= 24;
                break;
            case 'm':
                days /= 1440; /* minutes / day */
                break;
            case 's':
                days /= 86400; /* seconds / day */
                break;
            case 'ms':
                days /= MS.d;
                break;
        }
        return _d2M(days) / (isOutputMonths ? 1 : 12);
    }
    const ms = duration(durationInput, durationInputUnit);
    switch (durationOutputAsUnit) {
        case 's':
            return ms / MS.s;
        case 'm':
            return ms / MS.m;
        case 'h':
            return ms / MS.h;
        case 'd':
            return ms / MS.d;
        case 'w':
            return ms / MS.w;
    }
    return ms;
};
//# sourceMappingURL=durationAs.js.map